const accentColor = {
  name: "accent-color",
  path: "/accent-color",
  title: "accent-color",
  description: "Utilities for controlling the accented color of a form control.",
  value: {
  "color": {
    "accent-color-inherit": "inherit",
    "accent-color-current": "currentColor",
    "accent-color-transparent": "transparent",
    "accent-color-[value]": "[value]",
    "accent-color-black": "var(--color-black)",
    "accent-color-white": "var(--color-white)",
    "accent-color-red-50": "var(--color-red-50)",
    "accent-color-red-100": "var(--color-red-100)",
    "accent-color-red-200": "var(--color-red-200)",
    "accent-color-red-300": "var(--color-red-300)",
    "accent-color-red-400": "var(--color-red-400)",
    "accent-color-red-500": "var(--color-red-500)",
    "accent-color-red-600": "var(--color-red-600)",
    "accent-color-red-700": "var(--color-red-700)",
    "accent-color-red-800": "var(--color-red-800)",
    "accent-color-red-900": "var(--color-red-900)",
    "accent-color-orange-50": "var(--color-orange-50)",
    "accent-color-orange-100": "var(--color-orange-100)",
    "accent-color-orange-200": "var(--color-orange-200)",
    "accent-color-orange-300": "var(--color-orange-300)",
    "accent-color-orange-400": "var(--color-orange-400)",
    "accent-color-orange-500": "var(--color-orange-500)",
    "accent-color-orange-600": "var(--color-orange-600)",
    "accent-color-orange-700": "var(--color-orange-700)",
    "accent-color-orange-800": "var(--color-orange-800)",
    "accent-color-orange-900": "var(--color-orange-900)",
    "accent-color-amber-50": "var(--color-amber-50)",
    "accent-color-amber-100": "var(--color-amber-100)",
    "accent-color-amber-200": "var(--color-amber-200)",
    "accent-color-amber-300": "var(--color-amber-300)",
    "accent-color-amber-400": "var(--color-amber-400)",
    "accent-color-amber-500": "var(--color-amber-500)",
    "accent-color-amber-600": "var(--color-amber-600)",
    "accent-color-amber-700": "var(--color-amber-700)",
    "accent-color-amber-800": "var(--color-amber-800)",
    "accent-color-amber-900": "var(--color-amber-900)",
    "accent-color-yellow-50": "var(--color-yellow-50)",
    "accent-color-yellow-100": "var(--color-yellow-100)",
    "accent-color-yellow-200": "var(--color-yellow-200)",
    "accent-color-yellow-300": "var(--color-yellow-300)",
    "accent-color-yellow-400": "var(--color-yellow-400)",
    "accent-color-yellow-500": "var(--color-yellow-500)",
    "accent-color-yellow-600": "var(--color-yellow-600)",
    "accent-color-yellow-700": "var(--color-yellow-700)",
    "accent-color-yellow-800": "var(--color-yellow-800)",
    "accent-color-yellow-900": "var(--color-yellow-900)",
    "accent-color-lime-50": "var(--color-lime-50)",
    "accent-color-lime-100": "var(--color-lime-100)",
    "accent-color-lime-200": "var(--color-lime-200)",
    "accent-color-lime-300": "var(--color-lime-300)",
    "accent-color-lime-400": "var(--color-lime-400)",
    "accent-color-lime-500": "var(--color-lime-500)",
    "accent-color-lime-600": "var(--color-lime-600)",
    "accent-color-lime-700": "var(--color-lime-700)",
    "accent-color-lime-800": "var(--color-lime-800)",
    "accent-color-lime-900": "var(--color-lime-900)",
    "accent-color-green-50": "var(--color-green-50)",
    "accent-color-green-100": "var(--color-green-100)",
    "accent-color-green-200": "var(--color-green-200)",
    "accent-color-green-300": "var(--color-green-300)",
    "accent-color-green-400": "var(--color-green-400)",
    "accent-color-green-500": "var(--color-green-500)",
    "accent-color-green-600": "var(--color-green-600)",
    "accent-color-green-700": "var(--color-green-700)",
    "accent-color-green-800": "var(--color-green-800)",
    "accent-color-green-900": "var(--color-green-900)",
    "accent-color-emerald-50": "var(--color-emerald-50)",
    "accent-color-emerald-100": "var(--color-emerald-100)",
    "accent-color-emerald-200": "var(--color-emerald-200)",
    "accent-color-emerald-300": "var(--color-emerald-300)",
    "accent-color-emerald-400": "var(--color-emerald-400)",
    "accent-color-emerald-500": "var(--color-emerald-500)",
    "accent-color-emerald-600": "var(--color-emerald-600)",
    "accent-color-emerald-700": "var(--color-emerald-700)",
    "accent-color-emerald-800": "var(--color-emerald-800)",
    "accent-color-emerald-900": "var(--color-emerald-900)",
    "accent-color-teal-50": "var(--color-teal-50)",
    "accent-color-teal-100": "var(--color-teal-100)",
    "accent-color-teal-200": "var(--color-teal-200)",
    "accent-color-teal-300": "var(--color-teal-300)",
    "accent-color-teal-400": "var(--color-teal-400)",
    "accent-color-teal-500": "var(--color-teal-500)",
    "accent-color-teal-600": "var(--color-teal-600)",
    "accent-color-teal-700": "var(--color-teal-700)",
    "accent-color-teal-800": "var(--color-teal-800)",
    "accent-color-teal-900": "var(--color-teal-900)",
    "accent-color-cyan-50": "var(--color-cyan-50)",
    "accent-color-cyan-100": "var(--color-cyan-100)",
    "accent-color-cyan-200": "var(--color-cyan-200)",
    "accent-color-cyan-300": "var(--color-cyan-300)",
    "accent-color-cyan-400": "var(--color-cyan-400)",
    "accent-color-cyan-500": "var(--color-cyan-500)",
    "accent-color-cyan-600": "var(--color-cyan-600)",
    "accent-color-cyan-700": "var(--color-cyan-700)",
    "accent-color-cyan-800": "var(--color-cyan-800)",
    "accent-color-cyan-900": "var(--color-cyan-900)",
    "accent-color-sky-50": "var(--color-sky-50)",
    "accent-color-sky-100": "var(--color-sky-100)",
    "accent-color-sky-200": "var(--color-sky-200)",
    "accent-color-sky-300": "var(--color-sky-300)",
    "accent-color-sky-400": "var(--color-sky-400)",
    "accent-color-sky-500": "var(--color-sky-500)",
    "accent-color-sky-600": "var(--color-sky-600)",
    "accent-color-sky-700": "var(--color-sky-700)",
    "accent-color-sky-800": "var(--color-sky-800)",
    "accent-color-sky-900": "var(--color-sky-900)",
    "accent-color-blue-50": "var(--color-blue-50)",
    "accent-color-blue-100": "var(--color-blue-100)",
    "accent-color-blue-200": "var(--color-blue-200)",
    "accent-color-blue-300": "var(--color-blue-300)",
    "accent-color-blue-400": "var(--color-blue-400)",
    "accent-color-blue-500": "var(--color-blue-500)",
    "accent-color-blue-600": "var(--color-blue-600)",
    "accent-color-blue-700": "var(--color-blue-700)",
    "accent-color-blue-800": "var(--color-blue-800)",
    "accent-color-blue-900": "var(--color-blue-900)",
    "accent-color-indigo-50": "var(--color-indigo-50)",
    "accent-color-indigo-100": "var(--color-indigo-100)",
    "accent-color-indigo-200": "var(--color-indigo-200)",
    "accent-color-indigo-300": "var(--color-indigo-300)",
    "accent-color-indigo-400": "var(--color-indigo-400)",
    "accent-color-indigo-500": "var(--color-indigo-500)",
    "accent-color-indigo-600": "var(--color-indigo-600)",
    "accent-color-indigo-700": "var(--color-indigo-700)",
    "accent-color-indigo-800": "var(--color-indigo-800)",
    "accent-color-indigo-900": "var(--color-indigo-900)",
    "accent-color-violet-50": "var(--color-violet-50)",
    "accent-color-violet-100": "var(--color-violet-100)",
    "accent-color-violet-200": "var(--color-violet-200)",
    "accent-color-violet-300": "var(--color-violet-300)",
    "accent-color-violet-400": "var(--color-violet-400)",
    "accent-color-violet-500": "var(--color-violet-500)",
    "accent-color-violet-600": "var(--color-violet-600)",
    "accent-color-violet-700": "var(--color-violet-700)",
    "accent-color-violet-800": "var(--color-violet-800)",
    "accent-color-violet-900": "var(--color-violet-900)",
    "accent-color-purple-50": "var(--color-purple-50)",
    "accent-color-purple-100": "var(--color-purple-100)",
    "accent-color-purple-200": "var(--color-purple-200)",
    "accent-color-purple-300": "var(--color-purple-300)",
    "accent-color-purple-400": "var(--color-purple-400)",
    "accent-color-purple-500": "var(--color-purple-500)",
    "accent-color-purple-600": "var(--color-purple-600)",
    "accent-color-purple-700": "var(--color-purple-700)",
    "accent-color-purple-800": "var(--color-purple-800)",
    "accent-color-purple-900": "var(--color-purple-900)",
    "accent-color-fuchsia-50": "var(--color-fuchsia-50)",
    "accent-color-fuchsia-100": "var(--color-fuchsia-100)",
    "accent-color-fuchsia-200": "var(--color-fuchsia-200)",
    "accent-color-fuchsia-300": "var(--color-fuchsia-300)",
    "accent-color-fuchsia-400": "var(--color-fuchsia-400)",
    "accent-color-fuchsia-500": "var(--color-fuchsia-500)",
    "accent-color-fuchsia-600": "var(--color-fuchsia-600)",
    "accent-color-fuchsia-700": "var(--color-fuchsia-700)",
    "accent-color-fuchsia-800": "var(--color-fuchsia-800)",
    "accent-color-fuchsia-900": "var(--color-fuchsia-900)",
    "accent-color-pink-50": "var(--color-pink-50)",
    "accent-color-pink-100": "var(--color-pink-100)",
    "accent-color-pink-200": "var(--color-pink-200)",
    "accent-color-pink-300": "var(--color-pink-300)",
    "accent-color-pink-400": "var(--color-pink-400)",
    "accent-color-pink-500": "var(--color-pink-500)",
    "accent-color-pink-600": "var(--color-pink-600)",
    "accent-color-pink-700": "var(--color-pink-700)",
    "accent-color-pink-800": "var(--color-pink-800)",
    "accent-color-pink-900": "var(--color-pink-900)",
    "accent-color-rose-50": "var(--color-rose-50)",
    "accent-color-rose-100": "var(--color-rose-100)",
    "accent-color-rose-200": "var(--color-rose-200)",
    "accent-color-rose-300": "var(--color-rose-300)",
    "accent-color-rose-400": "var(--color-rose-400)",
    "accent-color-rose-500": "var(--color-rose-500)",
    "accent-color-rose-600": "var(--color-rose-600)",
    "accent-color-rose-700": "var(--color-rose-700)",
    "accent-color-rose-800": "var(--color-rose-800)",
    "accent-color-rose-900": "var(--color-rose-900)",
    "accent-color-slate-50": "var(--color-slate-50)",
    "accent-color-slate-100": "var(--color-slate-100)",
    "accent-color-slate-200": "var(--color-slate-200)",
    "accent-color-slate-300": "var(--color-slate-300)",
    "accent-color-slate-400": "var(--color-slate-400)",
    "accent-color-slate-500": "var(--color-slate-500)",
    "accent-color-slate-600": "var(--color-slate-600)",
    "accent-color-slate-700": "var(--color-slate-700)",
    "accent-color-slate-800": "var(--color-slate-800)",
    "accent-color-slate-900": "var(--color-slate-900)",
    "accent-color-gray-50": "var(--color-gray-50)",
    "accent-color-gray-100": "var(--color-gray-100)",
    "accent-color-gray-200": "var(--color-gray-200)",
    "accent-color-gray-300": "var(--color-gray-300)",
    "accent-color-gray-400": "var(--color-gray-400)",
    "accent-color-gray-500": "var(--color-gray-500)",
    "accent-color-gray-600": "var(--color-gray-600)",
    "accent-color-gray-700": "var(--color-gray-700)",
    "accent-color-gray-800": "var(--color-gray-800)",
    "accent-color-gray-900": "var(--color-gray-900)",
    "accent-color-zinc-50": "var(--color-zinc-50)",
    "accent-color-zinc-100": "var(--color-zinc-100)",
    "accent-color-zinc-200": "var(--color-zinc-200)",
    "accent-color-zinc-300": "var(--color-zinc-300)",
    "accent-color-zinc-400": "var(--color-zinc-400)",
    "accent-color-zinc-500": "var(--color-zinc-500)",
    "accent-color-zinc-600": "var(--color-zinc-600)",
    "accent-color-zinc-700": "var(--color-zinc-700)",
    "accent-color-zinc-800": "var(--color-zinc-800)",
    "accent-color-zinc-900": "var(--color-zinc-900)",
    "accent-color-neutral-50": "var(--color-neutral-50)",
    "accent-color-neutral-100": "var(--color-neutral-100)",
    "accent-color-neutral-200": "var(--color-neutral-200)",
    "accent-color-neutral-300": "var(--color-neutral-300)",
    "accent-color-neutral-400": "var(--color-neutral-400)",
    "accent-color-neutral-500": "var(--color-neutral-500)",
    "accent-color-neutral-600": "var(--color-neutral-600)",
    "accent-color-neutral-700": "var(--color-neutral-700)",
    "accent-color-neutral-800": "var(--color-neutral-800)",
    "accent-color-neutral-900": "var(--color-neutral-900)",
    "accent-color-stone-50": "var(--color-stone-50)",
    "accent-color-stone-100": "var(--color-stone-100)",
    "accent-color-stone-200": "var(--color-stone-200)",
    "accent-color-stone-300": "var(--color-stone-300)",
    "accent-color-stone-400": "var(--color-stone-400)",
    "accent-color-stone-500": "var(--color-stone-500)",
    "accent-color-stone-600": "var(--color-stone-600)",
    "accent-color-stone-700": "var(--color-stone-700)",
    "accent-color-stone-800": "var(--color-stone-800)",
    "accent-color-stone-900": "var(--color-stone-900)"
  }
},
  exampleData: [
    {
      example: {
        code: `
<p class="accent-color-blue-600 dark:accent-color-sky-400">The quick brown fox jumps over the lazy dog.</p>
<p class="accent-color-inherit">The quick brown fox jumps over the lazy dog.</p>
<p class="accent-color-blue-600/100 dark:accent-color-sky-400/100">The quick brown fox jumps over the lazy dog.</p>
<p class="accent-color-blue-600/75 dark:accent-color-sky-400/75">The quick brown fox jumps over the lazy dog.</p>
<p class="accent-color-blue-600/25 dark:accent-color-sky-400/25">The quick brown fox jumps over the lazy dog.</p>
<p class="accent-color-[#7ccf00] dark:accent-color-[#ecfcca]">The quick brown fox jumps over the lazy dog.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="accent-color-gray-600 text-sm dark:accent-color-gray-300 mb-10">
        Use <code class="accent-color-gray-800 dark:accent-color-white font-semibold">accent-color-rose-500</code> utilities to change the accent color of an element.
      </p>
      <div class="flex flex-wrap justify-center gap-6">
        <label class="flex items-center space-x-2">
            <input type="checkbox" checked="">
            <div class="text-sm font-semibold text-gray-900 dark:text-gray-200">Browser default</div>
        </label>
        <label class="flex items-center space-x-2">
            <input class="accent-color-pink-500" type="checkbox" checked="">
            <div class="text-sm font-semibold text-gray-900 dark:text-gray-200">Customized</div>
        </label>
      </div>
    `
  },
    {
      data: `
      <p class="accent-color-gray-600 text-sm dark:accent-color-gray-300 mb-10">
        Use the color opacity modifier to control the opacity of an element's accent color:
      </p>
      <div class="flex flex-wrap justify-center gap-6">
        <label class="flex items-center space-x-2">
            <input class="accent-color-purple-500/25" type="checkbox" checked="">
            <div class="text-sm font-semibold text-gray-900 dark:text-gray-200">accent-color-purple-500/25</div>
        </label>
        <label class="flex items-center space-x-2">
            <input class="accent-color-purple-500/75" type="checkbox" checked="">
            <div class="text-sm font-semibold text-gray-900 dark:text-gray-200">accent-color-purple-500/75</div>
        </label>
      </div>
    `
  }
]
}
export default accentColor;

<div class="sr-only">
<div class="flex flex-wrap justify-center gap-6">
        <label class="flex items-center space-x-2">
            <div class="text-sm font-semibold text-gray-900 dark:text-gray-200">Browser default</div>
        </label>
        <label class="flex items-center space-x-2">
            <div class="accent-color-pink-500" type="checkbox" checked=""/>
            <div class="text-sm font-semibold text-gray-900 dark:text-gray-200">Customized</div>
        </label>
      </div>
      <div class="flex flex-wrap justify-center gap-6">
   <label class="flex items-center space-x-2">
      <input class="accent-color-purple-500/25" type="checkbox" checked=""/>
      <div class="text-sm font-semibold text-gray-900 dark:text-gray-200">accent-color-purple-500/25</div>
   </label>
   <label class="flex items-center space-x-2">
      <input class="accent-color-purple-500/75" type="checkbox" checked=""/>
      <div class="text-sm font-semibold text-gray-900 dark:text-gray-200">accent-color-purple-500/75</div>
   </label>
</div>
</div>